import './styles.css';
import { StatusScreen } from '@servicetim/ui/components';
import { ConfigError, errorMessage, loadConfig } from '@servicetim/ui/lib';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { createAppRouter } from './routes/router';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing <div id="root">');
}
const root = createRoot(container);

/** Nothing renders until /config.json has been fetched and validated (for the admin surface). */
async function bootstrap(): Promise<void> {
  try {
    const config = await loadConfig('admin');
    const router = createAppRouter();
    root.render(
      <StrictMode>
        <App config={config} router={router} />
      </StrictMode>,
    );
  } catch (error) {
    root.render(
      <StrictMode>
        <StartupError error={error} />
      </StrictMode>,
    );
  }
}

function StartupError({ error }: { error: unknown }) {
  const details = error instanceof ConfigError ? error.issues : [];
  return (
    <StatusScreen
      tone="error"
      title="ServiceTim Admin could not start"
      description={errorMessage(error)}
      details={details}
    />
  );
}

void bootstrap();
